export const homeStrings = {
  dates: {
    recently: 'Recently',
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: (count) => `${count} days ago`,
  },
  firstTime: {
    eyebrow: 'Welcome to Hobtalk',
    title: 'Start with one thing you enjoy.',
    detail: 'Choose a hobby, add your first entry, and Hobtalk will shape your home around what you care about.',
    primaryAction: 'Choose a hobby',
    steps: ['Pick a hobby', 'Add one entry', 'Come back to continue'],
    firstEntryEyebrow: 'First entry',
    firstEntryTitle: 'Choose your starting point',
    allHobbiesAction: 'See all hobbies',
    starterIdeasEyebrow: 'Starter ideas',
    starterIdeasTitle: 'Get value in under a minute',
  },
  loading: {
    eyebrow: 'Home',
    title: 'Getting your hobbies ready.',
    detail: 'Loading your latest activity.',
  },
  profile: {
    fallbackName: 'there',
    eyebrow: 'Profile',
    title: 'Make Hobtalk yours',
    detail: 'Add a profile photo so shared trips and recipes feel more personal.',
    addPhoto: 'Add photo',
    uploadingPhoto: 'Uploading...',
    unsupportedPhotoType: 'Use a JPG, PNG, or WebP image.',
    uploadFailed: 'We could not upload that photo.',
    readFailed: 'Unable to read photo.',
    openAccount: 'Open account',
    welcomeBack: 'Welcome back',
    welcomeBackName: (name) => `Welcome back, ${name}`,
  },
  error: {
    eyebrow: 'Home',
    title: 'We could not load your feed.',
    detail: 'Your hobbies are still available. Try again, or open a hobby directly.',
    retry: 'Try again',
    openHobbies: 'Open hobbies',
  },
  returning: {
    snapshotEyebrow: 'Home',
    snapshotTitle: 'Your week',
    snapshotDetail: 'A quick read on what changed across your hobbies.',
    nextEyebrow: 'Up next',
    nextTitle: 'Pick up where you left off',
    recommendationsTitle: 'Ideas for you',
    recentEyebrow: 'Recent',
    recentTitle: 'Latest updates',
    recapEyebrow: 'Your recap',
    recapAction: 'View recap',
    recapDismiss: 'Not now',
  },
  empty: {
    feedTitle: 'Nothing needs attention right now',
    feedDetail: 'Recent plans, progress, and reviews will appear here when there is something useful to act on.',
    recentTitle: 'Nothing needs attention right now',
    recentDetail: 'Recent plans, progress, and reviews will appear here when there is something useful to act on.',
  },
  stats: {
    entriesThisWeek: 'Entries this week',
    activeHobbies: 'Active hobbies',
    favorites: 'Favorites',
    favoritesAdded: 'Favorites added',
    totalEntries: 'Total saved',
    upcomingPlans: 'Upcoming plans',
  },
  feed: {
    recommended: 'Recommended',
    open: 'Open',
    openCooking: 'Open cooking',
    mediaDetailLabel: 'About',
    ideaDetailLabel: 'Idea',
    recipeIdea: 'Recipe idea',
    tripIdea: 'Trip idea',
    fitnessIdea: 'Fitness idea',
    trailIdea: 'Trail idea',
    idea: 'Idea',
  },
};

export const feedTypeLabels = {
  reflect: 'Reflection',
  continue: 'Continue',
  complete: 'Finish details',
  plan: 'Planning',
  upcoming: 'Upcoming',
  decide: 'Decide',
  insight: 'Insight',
  popular: 'Starter idea',
  recommend: 'Recommended',
  recommendation: 'Recommended',
  starter: 'Starter idea',
};

export const starterHobbies = [
  { hobbyId: 'cooking', title: 'Save a favorite recipe', action: 'Add recipe', note: 'Start with something you already know you like.' },
  { hobbyId: 'movies', title: 'Add a movie', action: 'Add movie', note: 'Pick something you watched recently or want to see next.' },
  { hobbyId: 'tvshows', title: 'Start a series', action: 'Add show', note: 'Keep progress without needing to remember the episode.' },
  { hobbyId: 'reading', title: 'Add your current book', action: 'Add book', note: 'Save the book on your nightstand or your next read.' },
];

export const starterIdeas = [
  { hobbyId: 'fitness', title: 'A 20-minute walk', meta: 'Fitness', note: 'A simple first activity that gives you a useful baseline.' },
  { hobbyId: 'cooking', title: 'One reliable weeknight meal', meta: 'Recipe idea', note: 'Save the dish you would happily make again.' },
  { hobbyId: 'reading', title: 'The book you are already reading', meta: 'Reading', note: 'No discovery needed: start with what is already in progress.' },
  { hobbyId: 'traveling', title: 'A nearby weekend idea', meta: 'Travel', note: 'Add a destination you could realistically visit soon.' },
  { hobbyId: 'hiking', title: 'A nearby trail', meta: 'Hiking', note: 'Capture distance, difficulty, and notes for a trail close to home.' },
];
